<template>
  <div>
    <v-carousel v-bind="caruselAttrs" height=80>
      <v-carousel-item :key="index" v-for="(i,index) in chunkArray" class="px-12">
        <v-row justify="start" >
          <v-col cols="2" v-for="img in i" v-bind:key="img.id">
            <component @changed="onClickImage" v-bind:is="component" :img="img"></component>
          </v-col>
        </v-row>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
//Potrebno je definisati koji tip komponente treba ucitati kao Car - default ImageCard
import ImageCard from '@/components/images/ImageCard'
import IconCard from '@/components/images/IconCard'
export default {
  components: {
    ImageCard,
    IconCard
  },
  props: {
    chunkArray: Array,
    caruselProps: Object,
    component: {
      default: function() {
        return ImageCard
      }
    }
  },
  methods: {
    onClickImage(id) {
      this.$emit('selected', id)
    }
  },
  computed: {
    caruselAttrs() {
      return this.$attrs
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
